import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import ProImage from '../../shared/ProImage/ProImage';
import { useScreenSize } from '../../../helpers';
import ProLink from '../../shared/ProLink/ProLink';

export default function AssetCarouselSlide({
    tagging,
    title,
    postType,
    seoTitle,
    shortDescription,
    assetTarget,
    isDarkMode,
    readTime,
    publishDateAndTime,
    publishDateTime,
    mobileBannerImage,
    bannerImage,
    articleType,
    button,
    logicalName,
}) {
    const { isMobileScreen } = useScreenSize();
    const [descriptionHeight, setDescriptionHeight] = useState(0);
    const descriptionBlockClasses = classNames({
        'tw-block md:tw-hidden asset-carousel-slide-description': true,
        'tw-bg-black': isDarkMode,
        'tw-bg-gray-100': !isDarkMode,
        'tw-h-[185px] tw-flex tw-items-center': isMobileScreen,
    });
    const cleanedTitle = seoTitle.replace('- Sony Pro', '').trim() || null;

    useEffect(() => {
        let maxHeight = 0;
        document.querySelectorAll('.asset-carousel-slide-description').forEach(element => {
            const height = element.getBoundingClientRect().height;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        setDescriptionHeight(maxHeight);
    }, []);

    return (
        <div className="tw-w-full">
            <div className={descriptionBlockClasses}>
                <div className="tw-w-full tw-tracking-wide tw-leading-10 tw-z-20 tw-p-10">
                    <h2
                        className={classNames({
                            'tw-mb-5': true,
                            'tw-text-black': !isDarkMode,
                            'tw-text-white': isDarkMode,
                            'tw-font-sst-medium': true,
                        })}
                    >
                        {cleanedTitle}
                    </h2>
                    <ProLink
                        className="tw-inline-block tw-text-white hover:tw-cursor-pointer focus:tw-underline visited:tw-text-white"
                        to={button.buttonLink}
                    >
                        {`${button.buttonTitle} >`}
                    </ProLink>
                </div>
            </div>

            <div className="tw-bg-black tw-relative tw-w-full sm:tw-h-[450px] tw-overflow-hidden tw-object-cover">
                <ProImage
                    src={bannerImage}
                    srcMobile={mobileBannerImage}
                    className="tw-w-full tw-block tw-h-full tw-object-cover"
                />

                <div
                    className={classNames({
                        'tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-z-10 md:tw-block tw-hidden': true,
                        'tw-from-black tw-bg-black/0': isDarkMode,
                        'tw-from-white tw-bg-white/0': !isDarkMode,
                    })}
                />

                <div
                    className="tw-hidden md:tw-block tw-absolute tw-w-1/2 tw-tracking-wide tw-leading-10 tw-z-20 tw-pl-10"
                    style={{ top: ' 50%', transform: 'translateY(-50%)' }}
                >
                    <h2
                        style={{ color: isDarkMode ? 'white' : 'black' }}
                        className={classNames({
                            'tw-mb-5 h1': true,
                            'tw-font-sst-medium': true,
                        })}
                    >
                        {cleanedTitle}
                    </h2>
                    <ProLink className="tw-inline-block" to={button.buttonLink}>
                        <button
                            className={classNames(
                                {
                                    '!tw-m-0': true,
                                    'btn-solutions-light': !isDarkMode,
                                    'tw-text-sm': true,
                                },
                                'btn'
                            )}
                        >
                            <span className="tw-text-sm tw-leading-4.5">{button.buttonTitle}</span>
                        </button>
                    </ProLink>
                </div>
            </div>
        </div>
    );
}
